import React, { useCallback } from "react";

import { useNavigate } from "@reach/router";
import { toLocalStorage } from "kanopi-components/utils/browser";
import { setBearer } from "kw/api";
import { useGlobal } from "kanopi-components/useGlobal";
import { userFields } from "kw/api/fragments";
import { useAPI } from "kw/api/useAPI";
import { useUser } from "kw/auth/useUser";

export function UserHijackingHijackPage({ userId }: { userId: string }) {
  const navigate = useNavigate();
  const [, setAuth] = useGlobal("auth");
  const [hijack] = useGlobal("hijack");
  const { mutation } = useAPI();
  const nextUrl = hijack?.nextUrl ?? "/policies";
  const user = useUser();
  const hijackUser = useCallback(() => {
    mutation(
      {
        hijackUser: [
          {
            input: {
              userId: userId,
            },
          },
          {
            token: true,
            user: userFields,
          },
        ],
      },
      async (response) => {
        if (response?.hijackUser?.token) {
          setBearer(response.hijackUser.token);
          toLocalStorage("auth", response.hijackUser);
          await setAuth(response.hijackUser);
          navigate(`${nextUrl}`);
        }
      }
    );
  }, []);

  React.useEffect(() => {
    if (!user) {
      // If user is not logged in, redirect to login page
      navigate("/admin/login");
    } else if (user?.allowAdminPortalAccess) {
      // If user is agent, allow them to hijack
      hijackUser();
    } else if (user?.isHijacked) {
      // If user is hijacked, redirect to nextUrl.
      // This can prevent the user landing on this temp page
      navigate(`${nextUrl}`);
    } else {
      // If user is logged in but not an agent, redirect to policies page
      navigate("/policies");
    }
  }, []);

  return <></>;
}
